/**
 * Created by Ning Jiang on 2021-05-05.
 */

import {NolimitApplication} from "@nolimitcity/slot-launcher/bin/NolimitApplication";
import {StageLayer} from "@nolimitcity/slot-launcher/bin/StageLayer";

export enum Layers {
    // Layers order from the top to the bottom.
    SCATTER_METER = "scatterMeter",
    FS_MULTIPLIER = "multiplierIndicator",
    SCREENS = "screens",
    WIN_COUNT_UP = "win_count_up",
    BIG_WIN = "big_win",
    WIN_PRESENTATIONS = "win_presentations",
    BEER_LAYER = "beerLayer",
    PARTY_WIN = "party_win",
    STACK_ANIMS = "stackAnimation",
    LOGO="logo",
    FOREGROUND = "gameForeground",
    BIG_WIN_BANNER = "big_win_banner",
    WILD_3_LAYER ="wild_3_layer",
    PRETZEL_PARTY_WIN = "pretzel_party_win",
    HIGH_SYMBOLS_WIN = "high_symbols_win",
    LOW_SYMBOLS_WIN = "low_symbols_win",
    BETLINES = "betLines",
    HIGH_SYMBOLS = "high_symbols",
    GLOW_DIVIDERS='glow_dividers',
    LOW_SYMBOLS = "low_symbols",
    DIM_STAGE = "dimOverlay",
    REEL_ATTENTION = "reelAttention",
    REEL_BACKGROUND = "reel_background",
    BACKGROUND = "gameBackground"

}

export class SimpleStageLayer extends PIXI.Container implements StageLayer {

    constructor() {
        super();
    }

    // Note: these only check the direct children.
    public onResize(): void {
        this.children.forEach((child: any) => {
            if (child.onResize) {
                child.onResize();
            }
        });
    }

    public onOrientationChanged(): void {
        this.children.forEach((child: any) => {
            if (child.onOrientationChanged) {
                child.onOrientationChanged();
            }
        });
    }
}

export class OktoberfestLayers {
    constructor() {
        for (const key in Layers) {
            NolimitApplication.addLayerAt((<any>Layers)[key], new SimpleStageLayer(), 0);
        }
    }

    public static getLayer(name: string): StageLayer | undefined {
        return NolimitApplication.getLayerByName(name);
    }
}